// No Price Info Business Hours Logic
function checkBusinessHours() {
  const now = new Date();
  const easternTime = new Date(now.toLocaleString("en-US", { timeZone: "America/New_York" }));

  const day = easternTime.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  const hour = easternTime.getHours();

  // Check if it's Monday-Friday (1-5) and between 9 AM - 5 PM (9-17)
  const isBusinessHours = day >= 1 && day <= 5 && hour >= 9 && hour < 17;

  const liveChatOption = document.getElementById('live-chat-option');
  if (liveChatOption) {
    liveChatOption.style.display = isBusinessHours ? 'block' : 'none';
  }
}

function openLiveChat() {
  // Open Tawk.to live chat as a guest with visitor info
  if (typeof Tawk_API !== 'undefined') {
    // Maximize the chat window
    Tawk_API.maximize();
    
  } else {
    // Fallback if Tawk.to is not loaded yet
    console.log('Tawk.to not loaded, attempting to load...');
    if (window.Tawk_API) {
      window.Tawk_API.maximize();
    }
  }
}

// Check business hours when the page loads
document.addEventListener('DOMContentLoaded', checkBusinessHours);

// Check business hours every minute to handle time changes
setInterval(checkBusinessHours, 60000);
